export default "__VITE_ASSET__Cbi8R9te__"